module.exports = __webpack_public_path__ + "assets/images/Sample2.42b39d15.jpg";